import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { onUnmounted, PropType } from 'vue';
import { MonitoringItemModel } from '../../models';
import { TirPmButton, TirPmButtonVariantEnum, TirPmButtonSizeEnum } from 'tir-components';
import { RouterLink } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'monitoring-menu-item',
  props: {
  /** Элемент меню */
  menuItem: { type: Object as PropType<MonitoringItemModel>, required: true },
  /** Открыто ли меню */
  isSidebarOpen: { type: Boolean },
  /** Показывать только иконки */
  showOnlyIcons: { type: Boolean },
  /**Активный элемент мониторинга */
  active: { type: Boolean },
},
  emits: ["onComponentUnmount"],
  setup(__props, { emit }) {

const props = __props;





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RouterLink), {
    class: _normalizeClass(["monitoring-menu-item__block", { 'monitoring-menu-item__active-element': __props.active }]),
    to: { name: __props.menuItem.NameRouter }
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(TirPmButton), {
        class: _normalizeClass(["monitoring-menu-item__button", { 'monitoring-menu-item__close': !__props.isSidebarOpen && __props.showOnlyIcons }]),
        variant: _unref(TirPmButtonVariantEnum).LinkState,
        size: _unref(TirPmButtonSizeEnum).Small
      }, {
        leftSlot: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(__props.menuItem.Icon), { class: "monitoring-menu-item__icon" }))
        ]),
        default: _withCtx(() => [
          (__props.isSidebarOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["monitoring-menu-item__button-text", { 'monitoring-menu-item__button-text-visible': __props.isSidebarOpen && !__props.showOnlyIcons }])
              }, _toDisplayString(__props.menuItem.Title), 3))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class", "variant", "size"])
    ]),
    _: 1
  }, 8, ["class", "to"]))
}
}

})